/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './BreadCrumb.scss';

class BreadCrumb extends React.Component {
  getItem = (item, index) => {
    const { addLabelBreadcrumbSchema } = this.props;
    return item.link ? (
      <li
        itemscope="itemscope"
        itemtype="https://schema.org/ListItem"
        itemprop="itemListElement"
        key={item.id}
      >
        <>
          <Link
            to={item.link}
            itemprop="item"
            spa={item.spa === 'yes'}
            data-ga={`ATF_breadcrumb|${item.label}|`}
            ga4Data={[
              {
                event: 'user_click',
                type: 'breadcrumb',
                category: item.label,
              },
            ]}
          >
            <span itemprop="name">{item.label}</span>
          </Link>
          {typeof index !== 'undefined' && (
            <meta content={index + 1} itemprop="position" />
          )}
        </>
      </li>
    ) : item.label ? (
      <li
        {...(addLabelBreadcrumbSchema
          ? {
              itemscope: 'itemscope',
              itemtype: 'https://schema.org/ListItem',
              itemprop: 'itemListElement',
            }
          : {})}
      >
        {addLabelBreadcrumbSchema ? (
          <span itemprop="item">
            <span itemprop="name">{item.label}</span>
          </span>
        ) : (
          <span>{item.label}</span>
        )}
        {addLabelBreadcrumbSchema &&
          typeof index !== 'undefined' && (
            <meta content={index + 1} itemprop="position" />
          )}
      </li>
    ) : null;
  };

  render() {
    const { data, title, wrapperClass } = this.props;
    const titleItem = {
      label: title,
    };
    if (data && data instanceof Array && data.length > 0) {
      return (
        <div className={s[wrapperClass]}>
          <ul itemtype="https://schema.org/BreadcrumbList" itemscope="">
            {data.map((item, index) => this.getItem(item, index))}
            {titleItem.label && this.getItem(titleItem)}
          </ul>
        </div>
      );
    }
    return null;
  }
}

BreadCrumb.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
};
BreadCrumb.defaultProps = {
  wrapperClass: '',
};
export default BreadCrumb;
